<template>
  <div class="wine-slider">
  <div class="next-button">
    <AppButton type="link" size="xs" text="листайте" with-icon icon-position="right" @click="next">
      <template #right>
        <IconDefault name="arrow-right-long" size="s"></IconDefault>
      </template>
    </AppButton>
  </div>
  <swiper
    :modules="modules"
    :slides-per-view="1"
    :space-between="5"
    :initial-slide="0"
    :loop="true"
    :pagination="{ clickable: true }"
    @swiper="onSwiper"
    @slideChange="slideChange"
  >
    <swiper-slide v-for="(item, index) in items" :key="index">
      <div class="wine-slide">
        <div class="wine-slide-info">
        <div class="image">
          <img :src="item.image" :alt="item.title">
        </div>
        <div class="wine-info">
          <div class="title" v-html="item.title" />
          <div class=" subtitle" v-html="item.wine" />
        </div>
        </div>
        <div class="wine-slide-button">
          <AppButton type="secondary" is-fluid text="Подробнее про вино" size="s" @click="wineClick(item.code)"></AppButton>
        </div>
      </div>
    </swiper-slide>
  </swiper>
  </div>
</template>
<script setup lang="ts">
import type { Emits } from "@components/AppWineList/model";
import { usePagesStore } from "@stores/pages";
import type { Props } from '@components/AppWineList/model/model';
import AppButton from "@components/AppButton/index.vue";
import IconDefault from "@components/AppIcon/index.vue";
import { Swiper, SwiperSlide } from 'swiper/vue';
import {  Pagination } from 'swiper/modules';
import 'swiper/css';

defineOptions({
  name:'AppWineListSlider'
})
const pagesStore = usePagesStore();
const props = defineProps<Props>();
const modules = [Pagination];
const swiperInstance = ref(null);

const onSwiper = (swiper) => {
  swiperInstance.value = swiper;
};
const next = () => {
  swiperInstance.value.slideNext();
};
const slideChange = (swiper:Swiper)=>{
  const activeIndex =  swiper.realIndex;
  pagesStore.setHovered(props.items[activeIndex].code)
}
const wineClick = (page:string)=>{
  pagesStore.setPage(page)
}
</script>
<style scoped lang="scss">
.wine-slider {
  margin-bottom: var(--space-40);
  .swiper-slide{
  }
  .wine-slide {
    width: 82vw;
    margin: 0 auto;
    padding: var(--space-30) var(--space-16) var(--space-16) var(--space-16);
    border: 1px solid var(--color-primary-ghost-30);
    border-radius: var(--border-radius-xxs);
    &-info{
      display: flex;
      align-items: center;
      margin-bottom: var(--space-20);
      .image {
        width: 10rem;
        flex-shrink: 0;
        img {
          width: 100%;
          height: 15rem;
          object-fit: cover;
        }
      }

      .wine-info {
        margin-left: var(--space-20);

        .title {
          font-family: var(--ff-secondary);
          font-size: var(--font-size-32);
          color: var(--color-secondary);
          margin-bottom: var(--space-16);
          line-height: var(--font-size-28);
        }

        .subtitle {
          font-size: var(--font-size-14);
        }
      }
    }

  }
}
</style>